import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit ground tile: a 1x1 m slab exactly 0.06 thick (top at y = 0.06),
// centred on the origin, seating seamlessly against every other ground tile.
const LAWN = "#6fae4e";
const LAWN_DARK = "#5f9a42";

export const grassTile = defineModel({
  id: "grass-tile",
  batchId: "modern",
  name: "Grass tile",
  tags: ["modern", "outdoor", "ground", "garden", "lawn", "grass"],
  summary: "A 1x1 lawn tile with darker grass patches.",
  description:
    "A one-tile lawn slab of the Modern Living kit: exactly 1x1 m and 0.06 m " +
    "thick, with a few darker flush patches so it reads as grass from above. " +
    "Tiles seamlessly with every other ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: LAWN, position: [0, 0.03, 0] },
      // Darker flush patches, all inside the tile edge.
      {
        geometry: new THREE.BoxGeometry(0.26, 0.012, 0.2),
        color: LAWN_DARK,
        position: [-0.22, 0.06, -0.24],
      },
      {
        geometry: new THREE.BoxGeometry(0.2, 0.012, 0.24),
        color: LAWN_DARK,
        position: [0.26, 0.06, 0.1],
      },
      {
        geometry: new THREE.BoxGeometry(0.18, 0.012, 0.14),
        color: LAWN_DARK,
        position: [-0.06, 0.06, 0.32],
      },
    ];
  },
  animations: [],
});
